module.exports = __webpack_public_path__ + "static/img/team-build-03.c22fd69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-03.png
// module id = Igy2
// module chunks = 1